import { Badge } from 'antd';
import tw from 'twin.macro';

import { PRODUCT_ORDER_STATUS } from '@/constants';

interface Props {
  bg?: string;
  status: keyof typeof PRODUCT_ORDER_STATUS;
}

const StatusBadge = ({ bg, status }: Props) => {
  return (
    <Badge
      css={
        bg &&
        tw`p-[5px 12px] rounded-[8px] [.ant-badge-status-dot]:(box-content border-[2px] border-solid border-white)`
      }
      style={{ background: bg }}
      color={(() => {
        switch (status) {
          case 'PAYMENT_CONFIRMED':
          case 'PREPARING':
            return 'geekblue';
          case 'PENDING_PAYMENT':
            return 'gold';
          case 'HOLD':
          case 'CANCELLED':
            return 'red';
          case 'COMPLETED':
            return 'green';
          default:
            return undefined;
        }
      })()}
      text={PRODUCT_ORDER_STATUS[status]}
    />
  );
};

export default StatusBadge;
